import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Helpers } from '../../../helpers/Helpers';
import { RootState } from '../../../redux/store';
import { MenuComponent } from '../../../_metronic/assets/ts/components';
import { KTCard } from '../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../_metronic/helpers/components/KTCardBody';
import { KTIcon } from '../../../_metronic/helpers/components/KTIcon';
import Content from '../../../_metronic/layout/components/content/Content';
import { PageTitle } from '../../../_metronic/layout/core';
import toast from "react-hot-toast";
import { storeActivityIndicator, storeAreYouSureModalCallback, storeImageViewer } from '../../../redux/reducers/authSlice';
import { RoleService } from '../../../services/RoleService';
import { GetRoleListPagingAndFilterRequest, initialGetRoleListPagingAndFilterRequest } from '../../../models/request/role/GetRoleListPagingAndFilterRequest';
import TableFooter from '../../../components/TableFooter';
import { GetRoleListPagingAndFilterResponse, GetRoleListPagingAndFilterResponseData, GetRoleListPagingAndFilterResponseItem, initialGetRoleListPagingAndFilterResponseData } from '../../../models/response/role/GetRoleListPagingAndFilterResponse';
import { ColumnChooserModel } from '../../../models/common/ColumnChooserModel';
import { kolonlariBirlestir } from '../../../components/ColumnFilter/kolonBirlestir';
import { buildExcelRequest, ExcelExportMode } from '../../../helpers/excelExportRequest';
import { ExportRoleListResponse } from '../../../models/response/role/ExportRoleListResponse';
import { GetCompanyListResponse, GetCompanyListResponseItem } from '../../../models/response/company/GetCompanyListResponse';
import { CompanyService } from '../../../services/CompanyService';
import { CustomSingleSelectModel } from '../../../components/CustomSingleSelect';
import { GetConstantListResponse, GetConstantListResponseItem } from '../../../models/response/constant/GetConstantListResponse';
import { ConstantService } from '../../../services/ConstantService';
import { ToolbarWrapper } from '../../../_metronic/layout/components/toolbar';
import RefreshButton from '../../../components/RefreshButton';
import { DeleteRoleResponse } from '../../../models/response/role/DeleteRoleResponse';
import RoleListFilters from '../RoleAdd/Components/RoleListFilters';
import { useSortableColumns } from '../../../helpers/useSortableColumns';
import ColumnFilterRow from '../../../components/ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../../../components/ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions } from '../../../components/ColumnFilter/ColumnFilterTypes';
import { ColumnFilterModel } from '../../../models/common/ColumnFilterModel';

const RoleList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)
    const pageName = "Ayarlar > Rol Tanımları"
    const pageVersion = "1";
    const [data, setData] = useState<GetRoleListPagingAndFilterResponseData>(initialGetRoleListPagingAndFilterResponseData);
    const [filter, setFilter] = useState<GetRoleListPagingAndFilterRequest>(initialGetRoleListPagingAndFilterRequest);

    const getColumns = () => {
        var list: ColumnChooserModel[] = [];

        var str = localStorage.getItem(pageName + "-" + pageVersion + "-filters");

        list = [
            { title: 'Rol Adı', name: 'name', order: 0, isVisible: true },
            { title: 'Oluşturan', name: 'createdUser', order: 0, isVisible: true },
            { title: 'Güncelleyen', name: 'updatedUser', order: 0, isVisible: true }
        ];

        for (var i = 0; i < list.length; i++) {
            list[i].order = i + 1;
        }

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    const performPagination = (i: number) => {
        getData({
            ...filter,
            currentPage: i,
            skip: (i - 1) * filter.take
        });
    }

    const changeTake = (_take: number) => {
        getData({
            ...filter,
            currentPage: 1,
            skip: 0,
            take: _take
        });
    }

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)

        getData();
    }, [])

    const deleteRole = async () => {
        try {
            var selectedIds = data.items.filter(x => x.isSelected).map(x => x.roleId);

            dispatch(storeActivityIndicator(true))

            var response: DeleteRoleResponse = await RoleService.deleteRole(selectedIds);

            if (!response.isSuccess) {
                toast.error(response.message)
                dispatch(storeActivityIndicator(false))
                return;
            }

            toast.success(response.message)

            getData();
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
    }

    const updateRole = async (_id: string | undefined = undefined) => {
        navigate('/role/listadd?id=' + (_id ? _id : data.items.filter(x => x.isSelected)[0].roleId));
    }

    // Kolon filtresinde art arda istek gidebilir; yalnızca en son isteğin cevabı ekrana yazılır.
    const lastRequestNo = useRef(0);

    const getData = async (_filter: GetRoleListPagingAndFilterRequest | undefined = undefined) => {
        const requestNo = ++lastRequestNo.current;

        try {
            dispatch(storeActivityIndicator(true))

            if (_filter)
                setFilter(_filter);
            else
                _filter = {
                    ...filter
                };

            var response: GetRoleListPagingAndFilterResponse = await RoleService.getRoleListPagingAndFilter(_filter);

            if (requestNo != lastRequestNo.current)
                return;

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setData(response.data);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            // Daha yeni bir istek sürüyorsa yükleniyor göstergesi açık kalır.
            if (requestNo == lastRequestNo.current)
                dispatch(storeActivityIndicator(false))
        }
    }

    const setItemSelected = (_id: string) => {
        setData({
            ...data,
            items: data.items.map(function (x) {
                if (x.roleId == _id)
                    x.isSelected = !x.isSelected;
                return x;
            })
        })
    }

    const selectAll = () => {
        var isAllSelected = data.items.filter(x => x.companyId).length == data.items.filter(x => x.companyId && x.isSelected).length;

        setData({
            ...data,
            items: data.items.map(function (x) {
                if (x.companyId)
                    x.isSelected = !isAllSelected;

                return x;
            })
        })
    }

    const onSearchSubmit = (e: any) => {
        e.preventDefault()
        getData();
    }

    const excelExport = async (mode: ExcelExportMode) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response: ExportRoleListResponse = await RoleService.exportRoleList(buildExcelRequest(filter, mode, data.items.filter(x => x.isSelected).map(x => x.roleId), columns));

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            window.location.href = Helpers.getEndpoint() + "/Excels/" + response.data;
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    // Başlığa tıklayarak sıralanabilen kolonlar. Oluşturan/güncelleyen bilgisi listede yok.
    const sortableColumns = ['name'];

    const { thProps, sortArrow } = useSortableColumns(sortableColumns, filter, getData);

    // Kolon başlıklarının altındaki filtreler. Kolon adları backend'deki eşlemeyle
    // (RoleManager.ApplyColumnFilters) aynı.
    const columnFilterDefinitions: ColumnFilterDefinitions = {
        name: { type: 'text' },
        createdUser: { type: 'text' },
        updatedUser: { type: 'text' },
    };

    // Kolon filtresi değişince ilk sayfaya dönülür; sıralama ve sayfa boyu korunur.
    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => {
        getData({ ...filter, columnFilters: columnFilters, currentPage: 1, skip: 0 });
    }

    const getColumnValue = (item: GetRoleListPagingAndFilterResponseItem, column: string, index: number, className: string | undefined) => {
        if (column == "createdUser") {
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.roleId)} onDoubleClick={!item.companyId ? undefined : () => updateRole(item.roleId)}>{item.createdUser} - {item.createdDate}</td>
            )
        }
        else if (column == "updatedUser") {
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.roleId)} onDoubleClick={!item.companyId ? undefined : () => updateRole(item.roleId)}>{item.updatedUser} - {item.updatedDate}</td>
            )
        }
        else {
            var item2: any = item;
            return <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.roleId)} onDoubleClick={!item.companyId ? undefined : () => updateRole(item.roleId)}>{item2[column]}</td>;
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />
                <RoleListFilters
                    columns={columns}
                    excelExport={excelExport}
                    getColumns={getColumns}
                    pageName={pageName}
                    pageVersion={pageVersion}
                    setColumns={setColumns}
                    filter={filter}
                    getData={getData}
                    setFilter={setFilter}
                    selectedCount={data.items.filter(x => x.isSelected).length}
                    deleteFunction={deleteRole}
                    onSearchSubmit={onSearchSubmit}
                    updateFunction={updateRole}
                />
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                <KTCard className='mb-3'>
                    <KTCardBody className='py-2'>
                        <ColumnFilterChips
                            columns={columns}
                            definitions={columnFilterDefinitions}
                            filters={filter.columnFilters}
                            onChange={changeColumnFilters}
                        />

                        <div className='table-responsive new-table-container'>
                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        <th style={{ width: 1 }}>
                                            <div className='d-flex'>
                                                <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                    <input onChange={selectAll} className='form-check-input' type='checkbox' checked={data.items.filter(x => x.isSelected).length > 0 && data.items.filter(x => x.isSelected).length == data.items.filter(x => x.companyId).length} />
                                                </label>
                                            </div>
                                        </th>

                                        {
                                            columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; }).map((item, index) =>
                                                <th {...thProps(item.name)}>
                                                    {item.title}
                                                    {sortArrow(item.name)}
                                                </th>
                                            )
                                        }
                                    </tr>

                                    <ColumnFilterRow
                                        columns={columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; })}
                                        definitions={columnFilterDefinitions}
                                        filters={filter.columnFilters}
                                        onChange={changeColumnFilters}
                                        leadingCellCount={1}
                                    />
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.items.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.items.map((item, index) =>
                                            <tr style={{ background: item.isSelected ? 'rgba(204, 204, 204, 0.25)' : undefined }}>
                                                <td style={{ width: 1 }}>
                                                    {
                                                        item.companyId && (
                                                            <div className='d-flex'>
                                                                <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                                    <input onChange={() => setItemSelected(item.roleId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                                </label>
                                                            </div>
                                                        )
                                                    }
                                                </td>

                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column, columnIndex) => (
                                                        <React.Fragment>{getColumnValue(item, column.name, index, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </KTCardBody>

                    <TableFooter
                        changeTake={changeTake}
                        take={filter.take}
                        currentPage={filter.currentPage}
                        performPagination={performPagination}
                        totalPageCount={Math.ceil(data.totalRecordCount / filter.take)}
                        totalRecordCount={data.totalRecordCount}
                        selectedCount={data.items.filter(x => x.isSelected).length}
                    />
                </KTCard>
            </Content>
        </React.Fragment>
    )
}

export default RoleList;